import { Reveal } from "@/components/Reveal";
import { SEO } from "@/components/SEO";

const POLICY_SECTIONS = [
  {
    title: "Information We Collect",
    body: [
      "YES & AMEN does not currently require users to create an account or provide personal information to use the mobile application.",
      "The app does not currently collect names, email addresses, location information, contacts, photos, or other personally identifying information from users.",
      "When you access our website or app content, our servers and hosting providers may automatically receive limited technical information associated with a network request, such as an IP address and basic request information. This information may be retained in standard server logs for purposes such as operating, securing, and maintaining our services.",
    ],
  },
  {
    title: "Information Stored on Your Device",
    body: [
      "Certain information is stored locally on your device to provide app functionality, including saved favorites, app preferences, cached devotional content, and downloaded media used for offline playback.",
      "This information is stored on your device and is not transmitted to YES & AMEN.",
    ],
  },
  {
    title: "Sharing",
    body: [
      "When you use the app's sharing feature, YES & AMEN creates the content to be shared on your device and uses your device's native sharing functionality. YES & AMEN does not receive information about whom you share content with or which service you choose to use.",
    ],
  },
  {
    title: "Analytics, Advertising & Tracking",
    body: [
      "YES & AMEN does not currently use third-party advertising, behavioral tracking, or analytics services in the consumer mobile application.",
      "We do not sell your personal information.",
    ],
  },
  {
    title: "Third-Party Services",
    body: [
      "YES & AMEN relies on third-party service providers for infrastructure and hosting. These providers may process limited technical information as necessary to operate and secure their services.",
      "If you choose to share YES & AMEN content through another application or service, your interaction with that service is governed by its own privacy practices.",
    ],
  },
  {
    title: "Children's Privacy",
    body: [
      "YES & AMEN does not knowingly collect personal information from children through the mobile application. If we learn that personal information from a child has been collected inadvertently, we will take appropriate steps to delete it.",
    ],
  },
  {
    title: "Changes to This Policy",
    body: [
      "YES & AMEN is currently in development, and its features and services may change before or after public release. We may update this Privacy Policy as the product evolves or as our privacy practices change.",
      "Any updates will be posted on this page with a revised \u201cLast Updated\u201d date.",
    ],
  },
];

export default function Privacy() {
  return (
    <main data-testid="privacy-page" className="bg-[#FBF9F5]">
      <SEO
        title="Privacy | YES & AMEN"
        description="How YES & AMEN handles information across the website and mobile application."
      />
      <section className="mx-auto max-w-3xl px-6 pb-36 pt-40 sm:pt-48">
        <Reveal>
          <p className="text-[11px] font-semibold uppercase tracking-[0.35em] text-[#16233B]/50">
            Privacy
          </p>
        </Reveal>
        <Reveal delay={0.08}>
          <h1 className="mt-8 font-serif text-4xl font-normal tracking-tight text-[#16233B] sm:text-5xl">
            Privacy Policy
          </h1>
        </Reveal>
        <Reveal delay={0.12}>
          <p className="mt-5 text-[11px] font-semibold uppercase tracking-[0.3em] text-[#16233B]/40">
            Last Updated: September 8, 2026
          </p>
        </Reveal>
        <Reveal delay={0.18}>
          <p className="mt-8 max-w-2xl text-base leading-relaxed text-[#16233B]/65">
            YES &amp; AMEN respects your privacy. This Privacy Policy explains how information is
            handled when you visit the YES &amp; AMEN website or use the YES &amp; AMEN mobile
            application.
          </p>
        </Reveal>

        <div data-testid="privacy-policy-content" className="mt-16 space-y-14">
          {POLICY_SECTIONS.map((section) => (
            <Reveal key={section.title}>
              <section>
                <h2 className="font-serif text-2xl font-normal tracking-tight text-[#16233B]">
                  {section.title}
                </h2>
                <div className="mt-5 space-y-4">
                  {section.body.map((paragraph, i) => (
                    <p key={i} className="text-sm leading-relaxed text-[#16233B]/60 sm:text-base">
                      {paragraph}
                    </p>
                  ))}
                </div>
              </section>
            </Reveal>
          ))}
          <Reveal>
            <section>
              <h2 className="font-serif text-2xl font-normal tracking-tight text-[#16233B]">
                Contact
              </h2>
              <p className="mt-5 text-sm leading-relaxed text-[#16233B]/60 sm:text-base">
                If you have questions about this Privacy Policy or YES &amp; AMEN’s privacy
                practices, please contact us at{" "}
                <a
                  href="mailto:support@yesamen.app"
                  data-testid="privacy-email-link"
                  className="font-medium text-[#16233B] underline decoration-[#16233B]/30 underline-offset-4 transition-colors duration-300 hover:decoration-[#16233B]"
                >
                  support@yesamen.app
                </a>
                .
              </p>
            </section>
          </Reveal>
        </div>
      </section>
    </main>
  );
}
